const theme = {
    colors: {
        base: '#121212', // Black
        secondary: '#e9e9e9', // Medium Gray
        tertiary: '#f3f3f3', // Light Gray
        highlight: '#5b8bf7', // Light Blue
        blue: '#0072bb',
        text: '#544949',
        red: '#ff0020',
        greyBody: '#F7F7F7',
        greyBorder: '#967F7F',
        headerBorder: '#979797',
        linkButton: '#00A7CC',
        // Wihuri styles under
        green: '#487962',
        whiteText: '#d8e1da',
        beige: '#f9f8f6',
        lightGreenText: '#487762',
        lightGreenBg: '#d8e1da',
        lightGrey: '#e7e7e7',
        navigationLightGrey: '#e1e1e1',
        navigationDarkGrey: '#4a4a4a',
        mobileNavigationBorderGreen: '#819e87',
        inputLightGrey: '#e6e8ed',
        inputLightGreyText: '#c9c9c9',
        darkGreen: '#819e87',
        liftGreen: '#ebf0ec',
        budgetGrey: '#f9f9f9',
        invalidButtonGrey: '#d3d3d3',
        navigationContentPageGrey: '#686868',
        errorRed: '#aa0061'
    },
    sizes: {
        maxWidth: '1440px',
        maxWidthCentered: '650px',
        pageBody: '890px',
        tablet: '768px',
        mobile: '600px',
        imageBreakpoint: '1300px'
    },
    responsive: {
        small: '480px',
        medium: '768px',
        large: '960px',
        extraLarge: '1200px'
    },
}

export default theme
